import api from './api';
import type { ThemeConfig } from '@/types/theme';

export interface SystemSettings {
  id: string;
  companyName: string;
  companyLogo: string | null;
  logoUrlDark: string | null;
  logoUrlLight: string | null;
  primaryColor: string;
  secondaryColor: string;
  supportEmail: string | null;
  supportPhone: string | null;
  taxPercent: number;
  comm12Months: number;
  comm6Months: number;
  bdrMeetingCommissionReais?: number;
  closerRecorrenteFirstParcelPercent?: number;
  closerProjetoPercent?: number;
  commissionCalculationPeriod?: 'semanal' | 'mensal';
  commissionPaymentDay?: number;
  commissionClosingGraceDays?: number;
  commissionMinimumPaymentReais?: number;
  theme: ThemeConfig | null;
}

export type CommissionSettingsPayload = {
  bdrMeetingCommissionReais: number;
  closerRecorrenteFirstParcelPercent: number;
  closerProjetoPercent: number;
  commissionCalculationPeriod: 'semanal' | 'mensal';
  commissionPaymentDay: number;
  commissionClosingGraceDays: number;
  commissionMinimumPaymentReais: number;
};

export const systemService = {
  async getSettings() {
    const response = await api.get<{ success: boolean; data: SystemSettings }>('/system/settings/public');
    return response.data.data;
  },

  async getAdminSettings() {
    const response = await api.get<{ success: boolean; data: SystemSettings }>('/system/settings');
    return response.data.data;
  },

  async updateSettings(data: Partial<SystemSettings>) {
    const response = await api.patch<{ success: boolean; data: SystemSettings }>('/system/settings', data);
    return response.data.data;
  },

  async uploadBrandLogo(file: File, variant: 'dark' | 'light' | 'fallback') {
    const formData = new FormData();
    formData.append('logo', file);
    formData.append('variant', variant);
    const response = await api.post<{ success: boolean; data: { logoUrl: string; variant: string } }>(
      '/system/settings/logo',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return response.data.data;
  },
};
